import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SocialInitiativeInfoComponentShared } from '../../shared/social-initiative/social-initiative-info-component.shared';
import { CommunityView } from '../communities-store';

@Component({
  selector: 'app-info-community',
  templateUrl: './info-community.component.html',
  styleUrls: ['./info-community.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoCommunityComponent extends SocialInitiativeInfoComponentShared<CommunityView> {
  public get isHealthCommunity(): boolean {
    return this.entity.focus === 'HEALTH';
  }
}
